import React from 'react';

import { BaseCard, Box, Skeleton, Spacer } from '@bcp-nextgen-dx-component-factory/design-system';

export const Skeletons: React.FC = () => {
	const generateArrayDummy = Array(2).fill(1);
	return (
		<>
			<Skeleton variant={'dark'} width={904} height={41} />
			<Spacer vertical={40} />
			<Skeleton variant={'dark'} width={320} height={24} />
			{generateArrayDummy.map((_, i) => {
				return (
					<div key={`accountSkeleton_${i}`}>
						<Spacer vertical={16} />
						<BaseCard
							width={'100%'}
							height={72}
							web={{
								styles: {
									padding: 16,
								},
							}}
						>
							<Box
								styles={{
									flexDirection: 'column',
									flexGrow: 1,
								}}
							>
								<Box styles={{ flexDirection: 'row' }}>
									<Box>
										<Skeleton variant={'dark'} width={320} height={24} borderRadius={96} />
									</Box>
								</Box>
							</Box>
							<Box>
								<Box styles={{ flexDirection: 'column' }}>
									<Skeleton variant={'dark'} width={135} height={20} />
									<Skeleton variant={'dark'} width={135} height={20} />
								</Box>
								<Spacer horizontal={47} />
								<Box styles={{ flexDirection: 'column' }}>
									<Skeleton variant={'dark'} width={135} height={20} />
								</Box>
							</Box>
						</BaseCard>
					</div>
				);
			})}
		</>
	);
};
